// extracted by mini-css-extract-plugin
export default {"title":"_10qUlQw_cdS9u-7li7gWll"};